import request from '@/utils/request'

// 发送验证码
export function getCode(data) {
    return request({
        url: '/h5/sendCode', method: 'post', params: data
    })
}


// 注册
export function registerUser(data) {
    return request({
        url: '/h5/register', method: 'post', params: data
    })
}

// 找回密码
export function find(data) {
    return request({
        url: '/h5/find', method: 'post', params: data
    })
}

// 更换手机号码
export function replacePhone(data) {
    return request({
        url: '/h5/replacePhone', method: 'post', params: data
    })
}

// 登录
export function loginUser(data) {
    return request({
        url: '/h5/login', method: 'post', params: data
    })
}


// 注销
export function logOutUser() {
    return request({
        url: '/h5/logOut', method: 'post'
    })
}

// 获取当前登录用户
export function getLoginUser() {
    return request({
        url: '/h5/getUser', method: 'post'
    })
}


// 获取当前登录用户
export function getServerTime() {
    return request({
        url: '/h5/getServerTime', method: 'get'
    })
}
